export default "__VITE_ASSET__Dx$Vdw7Q__"